import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type ExamenColumna = components['schemas']['ExamenColumnaRead']
export type ExamenCelda = components['schemas']['ExamenCeldaRead']
export type ExamenFila = components['schemas']['ExamenFilaRead']
export type ExamenMatriz = components['schemas']['ExamenMatrizRead']

export type MatrizEstadoFiltro = components['schemas']['MatrizEstadoFiltro']

export function useExamenesMatriz(
  businessId: string | undefined,
  params: {page: number; search: string; estado?: MatrizEstadoFiltro}
) {
  return useQuery({
    queryKey: ['examenes-matriz', businessId, params],
    queryFn: async () =>
      (
        await api.get<ExamenMatriz>(`/businesses/${businessId}/examenes-matriz`, {
          params: {page: params.page, search: params.search || undefined, estado: params.estado},
        })
      ).data,
    enabled: !!businessId,
    placeholderData: (previous) => previous,
  })
}

// Conteo aproximado para el diálogo: una página de 100 que puede quedarse corta; la compuerta
// real es el 409 del servidor (`has_huecos`).
export function useExamenesHuecos(businessId: string | undefined) {
  return useQuery({
    queryKey: ['examenes-huecos', businessId],
    queryFn: async () => {
      const {data} = await api.get<ExamenMatriz>(`/businesses/${businessId}/examenes-matriz`, {
        params: {page: 1, page_size: 100},
      })
      const personas = new Set(
        data.items.filter((fila) => fila.celdas.some((c) => c.estado === 'falta')).map((fila) => fila.employee_id)
      )
      return personas.size
    },
    enabled: !!businessId,
  })
}
